import { Model, getAppStore } from '../../../../../@data';
import { CommandBarActions, IBuildCommandBarProps } from '../../../../../layout/GridPageV2';
import { getStore } from '../../@data';
import messages from '../ManagePage.messages';

export function getCommandBarItems(): IBuildCommandBarProps<Model> | undefined {
  const { publisher, account } = getAppStore();
  const { gridChannels, isLoading } = getStore();

  const commandBarItems: IBuildCommandBarProps<Model> | undefined =
    (gridChannels && gridChannels.length !== 0 && publisher && account) || isLoading
      ? {
          primaryButtonLabel: messages.create,
          includeActions: [CommandBarActions.new],
          includeFarActions: [
            CommandBarActions.searchBox,
            CommandBarActions.edit,
            CommandBarActions.activate,
            CommandBarActions.deactivate,
            CommandBarActions.delete,
            CommandBarActions.download,
            CommandBarActions.modifyColumns,
          ],
        }
      : undefined;

  return commandBarItems;
}
